import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import StorySection from './components/StorySection';
//import TeamSection from './components/TeamSection';
import ValuesSection from './components/ValuesSection';
//import FacilitySection from './components/FacilitySection';
import Footer from '../../components/Footer';

const About = () => {
  return (
    <>
      <Helmet>
        <title>About Us - Sri Dhanvantari Ayurvaidik Parishkar Kendra | Authentic Kerala Ayurveda Panchakarma Clinic</title>
        <meta 
          name="description" 
          content="Discover the legacy of Sri Dhanvantari AyurVaidik Parishkar Kendra — where authentic Ayurveda meets compassionate healing. Meet our expert physicians and therapists, and explore our holistic treatment facility dedicated to restoring health, balance, and well-being through the timeless wisdom of Ayurveda." 
        />
        <meta name="keywords" content="about sri dhanvantari ayurvaidik parishkar kendra, authentic ayurveda center, expert ayurvedic physicians & therapists, holistic healing, traditional therapy facility" />
        <meta property="og:title" content="About Us - Sri Dhanvantari Ayurvaidik Parishkar Kendra | Authentic Kerala Ayurveda Panchakarma Center" />
        <meta property="og:description" content="Discover the story behind Ayur Parishkar Kendra’s transformative approach to treating autoimmune and other chronic diseases through evidence-based Ayurvedic care." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/about" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16 lg:pt-20">
          <HeroSection />
          <StorySection />
         {/* <TeamSection/>*/}
          <ValuesSection />
          {/*<FacilitySection />*/}
        </main>
        
        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default About;